import { Suspense } from 'react';
import ErrorBoundary from '@/components/ErrorBoundary';
import ViewLoading from '@/components/ViewLoading';
import { type AuthUtils } from '@/shared/lib/utils';
import { type QueryClient } from '@tanstack/react-query';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';

interface RouterContext {
  queryClient: QueryClient;
  auth: AuthUtils;
}

export const rootRoute = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
});

// ! Reminder to redo this after the migration is complete
function RootLayout() {
  return (
    <ErrorBoundary>
      <Suspense fallback={<ViewLoading />}>
        <Outlet />
      </Suspense>
    </ErrorBoundary>
  );
}
